import {
  Modal,
  Dialog,
  DialogHeader,
  DialogContent,
  DialogFooter,
  ButtonGroup,
  PrimaryButton,
  Text,
} from "@certn/cascadia-react";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

interface ApplicationDiscrepancyErrorModalProps extends PropsWithChildren {
  onOpenChanged: () => void;
  isOpen: boolean;
  onReSign: () => void;
  buttonText: string;
}

export function ApplicationDiscrepancyErrorModal(
  props: ApplicationDiscrepancyErrorModalProps
) {
  const { t } = useTranslation();

  const { onOpenChanged, isOpen, onReSign, children, buttonText } = props;

  function onNavigate() {
    onOpenChanged();
    onReSign();
  }

  return (
    <Modal isOpen={isOpen}>
      <Dialog>
        <>
          <DialogHeader onClose={onOpenChanged}>
            {t("Consent Required")}
          </DialogHeader>
          <DialogContent>
            <Text style="form/body-secondary" color="text-weak">
              {children}
            </Text>
          </DialogContent>
          <DialogFooter>
            <ButtonGroup>
              <PrimaryButton
                size="medium"
                onPress={onNavigate}
                testID="pass-button"
              >
                {buttonText}
              </PrimaryButton>
            </ButtonGroup>
          </DialogFooter>
        </>
      </Dialog>
    </Modal>
  );
}
